import typography from "../../base/typography";
import borders from "../../base/borders";
import colors from "../../base/colors";

import pxToRem from "../../functions/pxToRem";

const { size, fontWeightMedium, fontWeightBold } = typography;
const { borderRadius } = borders;
const { text, primary, grey, action } = colors;

const tab = {
  styleOverrides: {
    root: {
      display: "flex" as const,
      alignItems: "center" as const,
      flexDirection: "row" as const,
      flex: "1 1 auto",
      textAlign: "center" as const,
      maxWidth: "unset !important",
      minWidth: "unset !important",
      minHeight: `${pxToRem(40)} !important`,
      fontSize: size.sm,
      fontWeight: fontWeightMedium,
      textTransform: "none" as const,
      lineHeight: 1.25,
      padding: `${pxToRem(9)} ${pxToRem(14)}`,
      borderRadius: borderRadius.sm,
      // Idle tabs must stay readable — slate body, not muted caption.
      color: `${grey[700]} !important`,
      gap: pxToRem(6),
      zIndex: 2,
      opacity: "1 !important",
      transition: "background-color 120ms ease, color 120ms ease",

      "&:hover": {
        color: `${text.primary} !important`,
        backgroundColor: action.hover,
      },

      "&.Mui-selected": {
        color: `${primary.main} !important`,
        fontWeight: fontWeightBold,
        backgroundColor: "transparent",

        "&:hover": {
          color: `${primary.main} !important`,
          backgroundColor: action.hover,
        },
      },

      "&.Mui-disabled": {
        color: `${text.disabled} !important`,
      },

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: "0 !important",
        fontSize: pxToRem(18),
        color: "inherit",
        opacity: 0.92,
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: "0 !important",
        fontSize: `${pxToRem(18)} !important`,
        color: "inherit",
        opacity: 0.92,
      },

      "&.Mui-selected .material-icons, &.Mui-selected .material-icons-round, &.Mui-selected svg": {
        opacity: 1,
      },
    },

    labelIcon: {
      paddingTop: pxToRem(4),
      minHeight: "unset",
    },
  },
};

export default tab;
